import styled from "styled-components";
import { motion } from "framer-motion";

export const ContactUsSectionWrapper = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  font-weight: 500;
  padding: 100px 20px 20px 20px;
  box-sizing: border-box; /* Include padding in width */

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding-top: 80px;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
`;

export const HeroWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 74px 20px;
  background-color: ${({ theme }) => theme.colors.heroBg.trim()};
  border-radius: 32px;
  overflow: hidden;
  min-height: 600px;

  @media ${({ theme }) => theme.media.mobile} {
    padding: 84px 8px 8px;
  }
`;

export const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px;
  max-width: 1200px;
  width: 100%;
  z-index: 2;
  text-align: center;

  @media ${({ theme }) => theme.media.mobile} {
    gap: 40px;
  }
`;

export const Heading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 44px;
  line-height: 1.3em;
  letter-spacing: -0.02em;
  color: #ffffff;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 28px;
    letter-spacing: unset;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 32px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);

  @media ${({ theme }) => theme.media.mobile} {
    padding: 40px 20px 20px;
  }
`;

export const FormHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 24px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);
  text-align: center;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 22px;
    line-height: 1.3em;
  }
`;

export const FormInner = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Input = styled.input`
  padding: 12px;
  border: 1px solid
    ${({ $hasError }) =>
      $hasError ? "#f95959" : "rgba(29, 29, 29, 0.1)"};
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  line-height: 1.5em;
  color: #1d1d1d;
  background-color: #ffffff;
  width: 100%;
  height: 48px;
  outline: none !important;
  box-shadow: none !important;

  &::placeholder {
    color: rgba(29, 29, 29, 0.5);
    opacity: 1; /* Firefox */
  }

  &:focus {
    border-color: ${({ $hasError }) =>
      $hasError ? "#f95959" : "rgba(29, 29, 29, 0.2)"};
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background-color: #1d1d1d;
  border-radius: 12px;
  border: none;
  box-shadow: none;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  color: #ffffff;
  width: 100%;
  position: relative;
  overflow: hidden;
  transition: background-color 0.3s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? "#1d1d1d" : "rgba(29, 29, 29, 0.85)"};
  }

  img {
    width: 20px;
    height: 20px;
  }

  @media ${({ theme }) => theme.media.mobile} {
    margin-bottom: 20px;
  }
`;

export const ContactsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;

export const ContactIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: #1d1d1d;
  border-radius: 50%;
  flex-shrink: 0;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const ContactLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);
  flex: 1 1 0%;
  text-align: left;
  text-decoration: none;
  transition: color 0.2s ease;
  align-self: ${(props) => props.$alignSelf || "auto"};
  margin: auto 0;
  // margin: 0;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    font-size: 14px;
  }

  &:hover {
    color: rgba(255, 96, 48, 1);
  }

  &:not([href]) {
    pointer-events: none;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  opacity: ${(props) => props.$opacity || 1};
  mix-blend-mode: ${(props) => props.$blend};
  border-radius: 36px;
`;

export const BackgroundBlur = styled.div`
  position: absolute;
  width: 90.29%;
  height: 35.57%;
  top: 85.86%;
  left: 50%;
  transform: translate(-50%, 0%);
  background: ${({ theme }) => theme.colors.blurBg.trim()};
  filter: blur(500px);
  border-radius: 50%;
  z-index: 1;
`;
